import React from 'react';
import { getInDecimal } from '../../../../services/util';

import { isEmpty, orderBy } from '../../../../util/lodashlike';
export const ITALIC_ROWS = [
  'Overseas Fund Transfer from high-risk country',
  'Overseas Fund Transfer to high-risk country'
];

const TRANSACTION_TYPE_CONST = 'transactionType';
const TRANSACTION_NAME_CONST = 'transactionName';

export const IN_DATA_ORDER_MAP = {
  'CDM-cash-deposit': {
    transactionType: 'CDM-cash-deposit',
    transactionName: 'CDM Deposit ',
    order: 0
  },
  'cash-equivalent-deposit': {
    transactionType: 'cash-equivalent-deposit',
    transactionName: 'Cash Deposit ',
    order: 1
  },
  'incoming-local-fund-transfer': {
    transactionType: 'incoming-local-fund-transfer',
    transactionName: 'Local Fund Transfer ',
    order: 2
  },
  'incoming-overseas-fund-transfer': {
    transactionType: 'incoming-overseas-fund-transfer',
    transactionName: 'Overseas Fund Transfer',
    order: 3
  },
  'incoming-overseas-fund-transfer TO-HIGH-RISK-COUNTRY': {
    transactionType: 'incoming-overseas-fund-transfer TO-HIGH-RISK-COUNTRY',
    transactionName: 'Overseas Fund Transfer from high-risk country',
    order: 4
  },
  'incoming-fund-transfer TO-HIGH-RISK-COUNTRY': {
    transactionType: 'incoming-fund-transfer TO-HIGH-RISK-COUNTRY',
    transactionName: 'Overseas Fund Transfer from high-risk country',
    order: 4
  },
  'incoming-cheque': {
    transactionType: 'incoming-cheque',
    transactionName: 'Cheque',
    order: 5
  },
  'card-payment': {
    transactionType: 'card-payment',
    transactionName: 'Card Payment',
    order: 6
  },
  'Misc-credit': {
    transactionType: 'Misc-credit',
    transactionName: 'Miscellaneous',
    order: 7
  },
  Total: {
    transactionType: 'Total',
    transactionName: 'Total',
    order: 8
  }
};

export const OUT_DATA_ORDER_MAP = {
  'ATM-withdrawal': {
    transactionType: 'ATM-withdrawal',
    transactionName: 'ATM Withdrawal ',
    order: 0
  },
  'cash-equivalent-withdrawal': {
    transactionType: 'cash-equivalent-withdrawal',
    transactionName: 'Cash Withdrawal ',
    order: 1
  },
  'outgoing-local-fund-transfer': {
    transactionType: 'outgoing-local-fund-transfer',
    transactionName: 'Local Fund Transfer ',
    order: 2
  },
  'outgoing-overseas-fund-transfer': {
    transactionType: 'outgoing-overseas-fund-transfer',
    transactionName: 'Overseas Fund Transfer ',
    order: 3
  },
  'outgoing-overseas-fund-transfer TO-HIGH-RISK-COUNTRY': {
    transactionType: 'outgoing-overseas-fund-transfer TO-HIGH-RISK-COUNTRY',
    transactionName: 'Overseas Fund Transfer to high-risk country',
    order: 4
  },
  'outgoing-fund-transfer TO-HIGH-RISK-COUNTRY': {
    transactionType: 'outgoing-fund-transfer TO-HIGH-RISK-COUNTRY',
    transactionName: 'Overseas Fund Transfer to high-risk country',
    order: 4
  },
  'outgoing-cheque': {
    transactionType: 'outgoing-cheque',
    transactionName: 'Cheque',
    order: 5
  },
  'card-charge': {
    transactionType: 'card-charge',
    transactionName: 'Card Charges ',
    order: 6
  },
  'Misc-debit': {
    transactionType: 'Misc-debit',
    transactionName: 'Miscellaneous',
    order: 7
  },
  Total: {
    transactionType: 'Total',
    transactionName: 'Total',
    order: 8
  }
};

/**
 * additionalTransactionTypes to be shown below collapsible panel
 * @type {({code: string, description: string}|{code: string, description: string})[]}
 */
export const additionalTransactionTypes = [
  {
    code: 'Net Amount',
    description: 'Net Amount'
  },
  {
    code: 'Ratio of Total In vs Total out',
    description: 'Ratio of Total In vs Total out'
  }
];

/**
 * getProcessedData for processing Stringified JSON in customer api
 * @param data
 * @param transactionTypes
 * @param orderedMap
 * @returns {unknown[]}
 */
export const getProcessedData = (data, transactionTypes, orderedMap = {}) => {
  const dataObject = {};
  if (data != undefined) {
    data.map((inRow) => {
      const transactionType = inRow[TRANSACTION_TYPE_CONST];
      const opType = inRow['operationType'];
      const lbDays = inRow['lookbackDays'];
      const value = inRow['value'];
      const lbDays_Key = opType + '_' + lbDays;
      const value_Key = opType + '_' + lbDays;
      if (dataObject[transactionType] === undefined) {
        dataObject[transactionType] = {};
        if (!isEmpty(orderedMap)) {
          if (orderedMap[transactionType] !== undefined) {
            const {
              transactionType: tType,
              transactionName: tName,
              order
            } = orderedMap[transactionType];
            dataObject[transactionType][TRANSACTION_TYPE_CONST] = tType;
            dataObject[transactionType][TRANSACTION_NAME_CONST] = tName;
            dataObject[transactionType]['order'] = order;
          }
        }
        if (dataObject[transactionType][TRANSACTION_TYPE_CONST] === undefined) {
          dataObject[transactionType][TRANSACTION_TYPE_CONST] = transactionType;
          let transactionName = transactionTypes.filter((t) => {
            return t.code === transactionType;
          });
          if (transactionName.length === 0) {
            transactionName = additionalTransactionTypes.filter((t) => {
              return t.code === transactionType;
            });
          }
          if (transactionName.length === 0) {
            if (transactionType === 'Total') {
              transactionName = 'Total';
            } else {
              transactionName = 'NA';
            }
          } else {
            transactionName = transactionName[0].description;
          }
          dataObject[transactionType][TRANSACTION_NAME_CONST] = transactionName;
        }
      }

      let formattedValue = value;
      if (
        dataObject[transactionType].transactionType ===
        'Ratio of Total In vs Total out'
      ) {
        formattedValue = getInDecimal(value);
      }

      Object.assign(dataObject[transactionType], {
        [lbDays_Key]: lbDays,
        [value_Key]: formattedValue
      });
    });
  }

  const objectValuesArray = Object.values(dataObject);
  if (!isEmpty(orderedMap)) {
    return orderBy(objectValuesArray, ['order'], ['asc']);
  }
  return objectValuesArray;
};

/**
 * excludedObjectForStyle for customer activity
 * @type {{totalAmount_360: boolean,
 * totalAmount_90: boolean,
 * count_360: boolean,
 * maxAmount_90: boolean,
 * totalAmount_180: boolean,
 * totalAmount_7: boolean,
 * count_180: boolean,
 * count_7: boolean,
 * totalAmount_30: boolean,
 * maxAmount_180: boolean, count_90: boolean,
 * maxAmount_30: boolean, maxAmount_7: boolean,
 * count_30: boolean, maxAmount_360: boolean}}
 */

export const excludedObjectForStyle = {
  totalAmount_7: true,
  maxAmount_7: true,
  count_7: true,
  totalAmount_30: true,
  maxAmount_30: true,
  count_30: true,
  totalAmount_90: true,
  maxAmount_90: true,
  count_90: true,
  totalAmount_180: true,
  maxAmount_180: true,
  count_180: true,
  totalAmount_360: true,
  maxAmount_360: true,
  count_360: true
};

export const CustomerActivityHeaderFirstPage = [
  {
    key: 'transactionName',
    name: 'transactionName'
  },
  {
    key: 'totalAmount_7',
    name: 'totalAmount_7',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'maxAmount_7',
    name: 'maxAmount_7',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'averageAmount_7',
    name: 'averageAmount_7',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'count_7',
    name: 'count_7'
  },
  {
    key: 'totalAmount_30',
    name: 'totalAmount_30',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'maxAmount_30',
    name: 'maxAmount_30',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'averageAmount_30',
    name: 'averageAmount_30',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'count_30',
    name: 'count_30'
  },
  {
    key: 'totalAmount_90',
    name: 'totalAmount_90',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'maxAmount_90',
    name: 'maxAmount_90',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'averageAmount_90',
    name: 'averageAmount_90',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'count_90',
    name: 'count_90'
  }
];

export const CustomerActivityHeaderSecondPage = [
  {
    key: 'totalAmount_180',
    name: 'totalAmount_180',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'maxAmount_180',
    name: 'maxAmount_180',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'averageAmount_180',
    name: 'averageAmount_180',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'count_180',
    name: 'count_180'
  },
  {
    key: 'totalAmount_360',
    name: 'totalAmount_360',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'maxAmount_360',
    name: 'maxAmount_360',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'averageAmount_360',
    name: 'averageAmount_360',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'count_360',
    name: 'count_360'
  }
];

/**
 * AlertHistoryHeader for customer activity
 * @returns {thead}
 * @constructor
 */
export const AlertHistoryHeader = ({ offset }) => {
  if (offset === 1) {
    return (
      <thead>
        <tr>
          <th>Transaction Type</th>
          <th colSpan="4">7 Days</th>
          <th colSpan="4">30 Days</th>
          <th colSpan="4">90 Days</th>
          <th colSpan="4">180 Days</th>
          <th colSpan="4">360 Days</th>
        </tr>
        <tr>
          <th style={{ color: 'transparent' }}>
            THISISARANDOMTEXTDON'TTOUCHTHIS
          </th>
          <th>
            <strong>Total</strong>
            <br />
            Amount(SGD)
          </th>
          <th>
            <strong>Maximum</strong>
            <br />
            Amount(SGD)
          </th>
          <th>
            <strong>Average</strong>
            <br />
            Amount(SGD)
          </th>
          <th>Count</th>
          <th>
            <strong>Total</strong>
            <br />
            Amount(SGD)
          </th>
          <th>
            <strong>Maximum</strong>
            <br />
            Amount(SGD)
          </th>
          <th>
            <strong>Average</strong>
            <br />
            Amount(SGD)
          </th>
          <th>Count</th>
          <th>
            <strong>Total</strong>
            <br />
            Amount(SGD)
          </th>
          <th>
            <strong>Maximum</strong>
            <br />
            Amount(SGD)
          </th>
          <th>
            <strong>Average</strong>
            <br />
            Amount(SGD)
          </th>
          <th>Count</th>
          <th>
            <strong>Total</strong>
            <br />
            Amount(SGD)
          </th>
          <th>
            <strong>Maximum</strong>
            <br />
            Amount(SGD)
          </th>
          <th>
            <strong>Average</strong>
            <br />
            Amount(SGD)
          </th>
          <th>Count</th>
          <th>
            <strong>Total</strong>
            <br />
            Amount(SGD)
          </th>
          <th>
            <strong>Maximum</strong>
            <br />
            Amount(SGD)
          </th>
          <th>
            <strong>Average</strong>
            <br />
            Amount(SGD)
          </th>
          <th>Count</th>
        </tr>
      </thead>
    );
  }
  return (
    <thead>
      <tr>
        <th>Transaction Type</th>
        <th colSpan="4">7 Days</th>
        <th colSpan="4">30 Days</th>
        <th colSpan="4">90 Days</th>
      </tr>
      <tr>
        <th style={{ color: 'transparent' }}>
          THISISARANDOMTEXTDON'TTOUCHTHIS
        </th>
        <th>
          <strong>Total</strong>
          <br />
          Amount(SGD)
        </th>
        <th>
          <strong>Maximum</strong>
          <br />
          Amount(SGD)
        </th>
        <th>
          <strong>Average</strong>
          <br />
          Amount(SGD)
        </th>
        <th>Count</th>
        <th>
          <strong>Total</strong>
          <br />
          Amount(SGD)
        </th>
        <th>
          <strong>Maximum</strong>
          <br />
          Amount(SGD)
        </th>
        <th>
          <strong>Average</strong>
          <br />
          Amount(SGD)
        </th>
        <th>Count</th>
        <th>
          <strong>Total</strong>
          <br />
          Amount(SGD)
        </th>
        <th>
          <strong>Maximum</strong>
          <br />
          Amount(SGD)
        </th>
        <th>
          <strong>Average</strong>
          <br />
          Amount(SGD)
        </th>
        <th>Count</th>
      </tr>
    </thead>
  );
};
